import type { GanttColumn } from "@/shared/components/gantt";

import styles from "../../gantt-obras.module.scss";

export const DESKTOP_COLUMNS: GanttColumn[] = [
  { key: "obra", header: "Obra", width: "var(--obra-col)", cellClassName: styles.obraCellFigma },
  {
    key: "profissionais",
    header: "Profissionais",
    width: "var(--people-col)",
    cellClassName: styles.peopleCellFigma,
  },
];

/** Mobile (Figma): uma só coluna fixa, com a obra e, expandida, os profissionais dela. */
export const MOBILE_COLUMNS: GanttColumn[] = [
  {
    key: "obra-profissional",
    header: "Obra / Profissional",
    width: "var(--obra-profissional-col)",
    cellClassName: styles.mobileCell,
  },
];
